<template>
  <div class="account-main--container">

    <div class="account-main--fields mrg-t-15">

      <div class="shadow-card">
        <div class="text-bold">
          Данные учетной записи
        </div>
        <div v-if="checkPermission('user')" class="text-small">
          Очень важно, чтобы данные были настоящие. Это существенно облегчит процесс восстановления доступа
          к аккаунту при его утере.
        </div>
        <div class="item email">
          <div class="field text-bold">E-mail</div>
          <div class="val">{{user.email}}</div>
          <div v-if="checkPermission('user')" class="action text-link">
            <span @click="showEditEmailPopup">Изменить E-mail</span>
          </div>
        </div>

        <div class="item username">
          <div class="text-bold">Ваше ФИО</div>
          <div>{{user.username}}</div>
          <div v-if="checkPermission('user')" class="action text-link">
            <span @click="showEditFIOPopup">Изменить ФИО</span>
          </div>
        </div>

        <div class="item phone_number">
          <div class="text-bold">Контактный номер телефона</div>
          <div v-if="user.phone_number">{{user.phone_number}}</div>
          <div v-if="!user.phone_number">-</div>
          <div v-if="checkPermission('user')" class="action text-link">
            <span @click="showEditPhonePopup">Изменить номер</span>
          </div>
        </div>
      </div>

      <div v-if="checkPermission('edit_password')" class="shadow-card mrg-t-10">
        <div class="text-bold">
          Изменение пароля учетной записи
        </div>
        <div class="text-small">
          Очень важно, чтобы пароль был сложный. Это существенно снижает риски несанкционированного доступа
        </div>
        <div class="mrg-t-15 input-block">
          <label>Введите старый пароль</label>
          <input type="password" v-model="oldPassword" />
        </div>
        <div class="input-block">
          <label>Введите новый пароль</label>
          <input type="password" v-model="newPasswordOne" />
          <div class="hint">Не менее 6 символов</div>
        </div>
        <div class="input-block">
          <label>Повторите пароль</label>
          <input type="password" v-model="newPasswordTwo" />
          <div class="hint">Не менее 6 символов</div>
        </div>
        <div class="mrg-t-10 text-hint">
          После изменения пароля, вас выбросит из аккаунта. Необходимо будет войти заново с уже
          новым паролем
        </div>
        <div class="input-block mrg-t-10">
          <div @click="editPasswordFinal" class="btn btn-sm btn-success">Изменить пароль</div>
        </div>
      </div>

    </div>

    <popup
      :closeButton="editEmailPopup.closeButton"
      :show="editEmailPopup.show"
      @closePopup="closeEditEmailPopup"
    >
      <div slot="header">Изменение e-mail учетной записи</div>
      <div slot="body">

        <div class="step-1">
          <div class="text-bold text-center">Шаг 1.</div>
          <div class="input-block mrg-t-10">
            <label>Введите новый e-mail</label>
            <input type="text" v-model="newEmail" :disabled="showStepTwoEditEmail" />
          </div>
          <div v-if="!showStepTwoEditEmail" class="input-block">
            <div @click="checkBeforeEditEmail" class="btn btn-sm btn-success">Продолжить</div>
          </div>
        </div>

        <div v-if="showStepTwoEditEmail" class="step-2 mrg-t-15">
          <div class="text-bold text-center">Шаг 2.</div>
          <div>
            Мы выслали вам 2 кода подтверждения. Один на старый адрес электронной почты, другой на новый электронный адрес.
            Введите их и нажмите "Сменить адрес".
          </div>

          <div class="input-block mrg-t-10">
            <label>Код, который вы получили на <b>{{user.email}}</b></label>
            <input type="text" v-model="editEmailCodes.edit_email_1" />
          </div>

          <div class="input-block mrg-t-10">
            <label>Код, который вы получили на <b>{{newEmail}}</b></label>
            <input type="text" v-model="editEmailCodes.edit_email_2" />
          </div>

          <div class="mrg-t-10 text-small">
            Как только вы нажмете "Сменить адрес", вас выбросит из учетной записи и необходимо будет
            войти с новым e-mail и старым паролем
          </div>

          <div class="input-block mrg-t-10">
            <div @click="editEmailFinal" class="btn btn-sm btn-success">Сменить адрес</div>
          </div>
        </div>

      </div>
    </popup>

    <popup
      :closeButton="editFIOPopup.closeButton"
      :show="editFIOPopup.show"
      @closePopup="closeEditFIOPopup"
    >
      <div slot="header">Изменение ФИО учетной записи</div>
      <div slot="body">

        <div class="step-1">
          <div class="text-bold text-center">Шаг 1.</div>
          <div class="input-block mrg-t-10">
            <label>Введите новое ФИО</label>
            <input type="text" v-model="newFIO" :disabled="showStepTwoEditFIO" />
          </div>
          <div v-if="!showStepTwoEditFIO" class="input-block">
            <div @click="checkBeforeEditFIO" class="btn btn-sm btn-success">Продолжить</div>
          </div>
        </div>

        <div v-if="showStepTwoEditFIO" class="step-2 mrg-t-15">
          <div class="text-bold text-center">Шаг 2.</div>
          <div>
            Мы выслали вам код подтверждения на электронную почту для смены ФИО.
            Введите его и нажмите "Сменить ФИО".
          </div>

          <div class="input-block mrg-t-10">
            <label>Код, который вы получили на <b>{{user.email}}</b></label>
            <input type="text" v-model="editFIOCode" />
          </div>

          <div class="input-block mrg-t-10">
            <div @click="editFIOFinal" class="btn btn-sm btn-success">Сменить ФИО</div>
          </div>
        </div>

      </div>
    </popup>


    <popup
      :closeButton="editPhonePopup.closeButton"
      :show="editPhonePopup.show"
      @closePopup="closeEditPhonePopup"
    >
      <div slot="header">Изменение Номера Телефона учетной записи</div>
      <div slot="body">

        <div class="step-1">
          <div class="text-bold text-center">Шаг 1.</div>
          <div class="input-block mrg-t-10">
            <label>Введите новый номер</label>
            <input type="text" v-model="newPhone" :disabled="showStepTwoEditPhone" />
          </div>
          <div v-if="!showStepTwoEditPhone" class="input-block">
            <div @click="checkBeforeEditPhone" class="btn btn-sm btn-success">Продолжить</div>
          </div>
        </div>

        <div v-if="showStepTwoEditPhone" class="step-2 mrg-t-15">
          <div class="text-bold text-center">Шаг 2.</div>
          <div>
            Мы выслали вам код подтверждения на электронную почту для смены номера телефона.
            Введите его и нажмите "Сменить номер".
          </div>

          <div class="input-block mrg-t-10">
            <label>Код, который вы получили на <b>{{user.email}}</b></label>
            <input type="text" v-model="editPhoneCode" />
          </div>

          <div class="input-block mrg-t-10">
            <div @click="editPhoneFinal" class="btn btn-sm btn-success">Сменить номер</div>
          </div>
        </div>

      </div>
    </popup>

  </div>
</template>

<script>

import Validator from "../../libraries/Validator";
import Popup from '../../Popup.vue';
import permissionMixin from "@/components/mixins/Permissions";
import userRepository from "../../../repositories/user";

const validator = new Validator();

export default {
  name: "AccountMain",
  components: {Popup },
  mixins: [permissionMixin],
  data() {
    return {
      editEmailPopup: {
        show: false,
        closeButton: "Отмена",
      },
      newEmail: '',
      showStepTwoEditEmail: false,
      editEmailCodes: {
        edit_email_1: '',
        edit_email_2: ''
      },

      newFIO: '',
      showStepTwoEditFIO: false,
      editFIOCode: '',
      editFIOPopup: {
        show: false,
        closeButton: "Отмена",
      },

      newPhone: '',
      showStepTwoEditPhone: false,
      editPhoneCode: '',
      editPhonePopup: {
        show: false,
        closeButton: "Отмена",
      },

      oldPassword: '',
      newPasswordOne: '',
      newPasswordTwo: '',

      user: {
        email: '',
        username: '',
        phone_number: ''
      },
      formError: {
        username: '',
        phone_number: ''
      }
    };
  },
  props: {

  },
  watch: {},
  computed: {

  },
  methods: {
    editPasswordFinal(){
      if(this.newPasswordOne !== this.newPasswordTwo){
        this.$store.dispatch("addNotification", {
          text: 'Новый пароль не совпадает',
          time: 4,
          color: "danger"
        });
        return false;
      }

      this.$store.dispatch("startPreloader");

      userRepository.editPassword({old: this.oldPassword, new: this.newPasswordTwo}).then(resp => {
        if(resp.data.result === 'ok'){
          this.oldPassword = '';
          this.newPasswordOne = '';
          this.newPasswordTwo = '';
          this.$store.dispatch("addNotification", {
            text: 'Успешно',
            time: 3,
            color: "success"
          });
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    closeEditPhonePopup(){
      this.editPhonePopup.show = false;
    },
    showEditPhonePopup(){
      this.editPhonePopup.show = true;
    },
    checkBeforeEditPhone(){
      let validate = validator.validate([
      {
          fieldName: "Новый номер",
          value: this.newPhone,
          type: "required",
          length: 20
        },
      ]);
      if(validate.result == "error"){
        this.$store.dispatch("addNotification", {
          text: validate.message,
          time: 4,
          color: "danger"
        });
        return false;
      }

      this.$store.dispatch("startPreloader");

      userRepository.beforeEditPhone().then(resp => {
        if(resp.data.result === 'ok'){
          this.showStepTwoEditPhone = true;
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    editPhoneFinal(){
      if(this.editPhoneCode == ''){
        this.$store.dispatch("addNotification", {
          text: 'Вы не ввели код подтверждения',
          time: 4,
          color: "danger"
        });
        return false;
      }

      this.$store.dispatch("startPreloader");

      userRepository.editPhone({code: this.editPhoneCode, new_phone: this.newPhone}).then(resp => {
        if(resp.data.result === 'ok'){
          this.closeEditPhonePopup();
          this.editPhoneCode = '';
          this.newPhone = '';
          this.showStepTwoEditPhone = false;
          this.getInfo();

          this.$store.dispatch("addNotification", {
            text: 'Успешно',
            time: 3,
            color: "success"
          });
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },

    closeEditFIOPopup(){
      this.editFIOPopup.show = false;
    },
    showEditFIOPopup(){
      this.editFIOPopup.show = true;
    },
    checkBeforeEditFIO(){
      let validate = validator.validate([
      {
          fieldName: "Новое ФИО",
          value: this.newFIO,
          type: "required",
          length: 250
        },
      ]);
      if(validate.result == "error"){
        this.$store.dispatch("addNotification", {
          text: validate.message,
          time: 4,
          color: "danger"
        });
        return false;
      }

      this.$store.dispatch("startPreloader");

      userRepository.beforeEditFio().then(resp => {
        if(resp.data.result === 'ok'){
          this.showStepTwoEditFIO = true;
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    editFIOFinal(){
      if(this.editFIOCode == ''){
        this.$store.dispatch("addNotification", {
          text: 'Вы не ввели код подтверждения',
          time: 4,
          color: "danger"
        });
        return false;
      }

      this.$store.dispatch("startPreloader");

      userRepository.editFio({code: this.editFIOCode, new_fio: this.newFIO}).then(resp => {
        if(resp.data.result === 'ok'){
          this.closeEditFIOPopup();
          this.editFIOCode = '';
          this.newFIO = '';
          this.showStepTwoEditFIO = false;
          this.getInfo();

          this.$store.dispatch("addNotification", {
            text: 'Успешно',
            time: 3,
            color: "success"
          });
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },

    closeEditEmailPopup(){
      this.editEmailPopup.show = false;
    },
    showEditEmailPopup(){
      this.editEmailPopup.show = true;
    },
    editEmailFinal(){
      if(this.editEmailCodes.edit_email_1 == '' || this.editEmailCodes.edit_email_2 == ''){
        this.$store.dispatch("addNotification", {
          text: 'Вы не ввели коды подтверждения',
          time: 4,
          color: "danger"
        });
        return false;
      }

      this.$store.dispatch("startPreloader");

      userRepository.editEmail({
        edit_email_1: this.editEmailCodes.edit_email_1,
        edit_email_2: this.editEmailCodes.edit_email_2
      }).then(resp => {
        if(resp.data.result === 'ok'){
          this.closeEditEmailPopup();
          this.getInfo();
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    checkBeforeEditEmail(){
      let validate = validator.validate([
      {
          fieldName: "Новый e-mail",
          value: this.newEmail,
          type: "required",
          length: 250
        },
        {
          fieldName: "Новый e-mail",
          value: this.newEmail,
          type: "email",
          length: 250
        }
      ]);
      if(validate.result == "error"){
        this.$store.dispatch("addNotification", {
          text: validate.message,
          time: 4,
          color: "danger"
        });
        return false;
      }

      this.$store.dispatch("startPreloader");

      userRepository.beforeEditEmail({new_email: this.newEmail}).then(resp => {
        if(resp.data.result === 'ok'){
          this.showStepTwoEditEmail = true;
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    getInfo(){
      userRepository.getMyAccount().then(resp => {
        this.user = resp.data;
        if(resp.data.phone_number === null){
          this.user.phone_number = '';
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
  },
  created() {
    this.getInfo();
  }
};
</script>

<style scoped lang="less">
.account-main--container{
  width: 50%;
}
.account-main--fields{
  .item{
    margin-top: 20px;

    .field{

    }
    .val{
      margin-top: 2px;
    }
    .action{
      margin-top: 3px;
      cursor: pointer;
    }
  }
}
@media (max-width: 1400px) {
  .account-main--container{
    width: 100%;
  }
}
</style>
